module.exports = __webpack_public_path__ + "img/image59.f131f570.png";